import * as React from 'react';

import { Posts } from '../../../Home/Posts/Posts';

export interface IAppProps {
}

export function ProfilePostLeftSide(props: IAppProps) {

    return (
        <div className="flex-1 profile_posts_left_side_section text-left xs:order-2 xl:order-1 pb-16 w-full">



            <div>
                <Posts />
            </div>






        </div>
    );
}
